export interface IPostView {
  ocorrenciaNo: number;
  idPost: any;
  idView: any;
  idPessoa: any;
  codigo: any;
  titulo: any;
  habilitado: boolean;
}
